import { testIf } from '../validationFunctions';
import { mergeArrays } from '../../mergeFunctions';
import { successState, formatResults } from '../validationHelpers';

export const validatePasswordSecret = ({ data, setNotificationText }) => {
  const emptyRes = testIf('empty')(data, ['name', 'username', 'password', 'vault_id']);
  const lengthRes = testIf('shorterThan')(data, ['name'], 50);

  const testResults = mergeArrays([emptyRes, lengthRes]);
  if (testResults.length === 0) return successState(setNotificationText);
  setNotificationText(formatResults(testResults));
};
